import { styled } from '../../hooks/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const CheckPointContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: -${props => props.theme.spacing.xxSmall + 'px'};
  gap: ${props => props.theme.spacing.xSmall + 'px'};
`;

export const TimelineContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: ${props => props.theme.spacing.xSmall + 'px'} 0 0;
  gap: ${props => props.theme.spacing.xxSmall + 'px'};
`;

type PointProps = {
  active: boolean;
};

export const Point = styled.span<PointProps>`
  height: 10px;
  width: 10px;
  background-color: ${props =>
    props.active ? props.theme.colors.brand.primary[80] : props.theme.colors.neutral.grey[40]};
  border-radius: ${props => props.theme.borderRadius.pill + 'px'};
`;

type BarProps = {
  shouldDisplay: boolean;
};

export const Bar = styled.div<BarProps>`
  width: 2px;
  height: 85%;

  background-color: ${props => props.theme.colors.neutral.grey[40]};
  border-radius: ${props => props.theme.borderRadius.md + 'px'};

  display: ${props => (props.shouldDisplay ? 'block' : 'none')};
`;

export const TextSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: ${props => Number(props.theme.spacing.xxSmall) / 2}px;
  min-height: 85px;
  height: auto;

  font-weight: ${props => props.theme.font.weights.regular};
  font-size: ${props => props.theme.font.size.xs + 'px'};
  line-height: ${props => props.theme.font.lineHeights['2']};
  color: ${props => props.theme.colors.neutral.grey[100]};
`;

type TitleProps = {
  active: boolean;
};

export const CheckPointTitle = styled.span<TitleProps>`
  font-size: ${props => props.theme.font.size.base + 'px'};
  font-weight: ${props =>
    props.active
      ? props.theme.font.desktop.paragraph.p1.semibold.fontWeight
      : props.theme.font.desktop.paragraph.p1.regular.fontWeight};
  line-height: ${props => props.theme.font.lineHeights[2]};

  color: ${props =>
    props.active ? props.theme.colors.neutral.grey[100] : props.theme.colors.neutral.grey[70]};
`;

export const CheckPointSubTitle = styled.span`
  font-family: 'Inter';
  font-size: ${props => props.theme.font.size.xs + 'px'};
  font-weight: ${props => props.theme.font.weights.regular};
  line-height: ${props => props.theme.font.lineHeights[2]};
  color: ${props => props.theme.colors.neutral.grey[70]};

  margin: ${props => props.theme.spacing.xxSmall}px 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-top: ${props => props.theme.spacing.xSmall + 'px'};
  margin-bottom: ${props => props.theme.spacing.medium + 'px'};
  gap: ${props => props.theme.spacing.xSmall + 'px'};

  font-family: ${props => props.theme.font.family.sans};
`;
